import { Grid } from '@mui/material';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Simplebar from 'components/Simplebar';
import React from 'react';
import { Bar, BarChart, ResponsiveContainer, XAxis } from 'recharts';

import { useAdvertisersDashboard } from '../AdvertisersDashboardContext';
import { formatAdsRunData } from './utils';

const BAR_COLOR = '#1a72c6';

const AdsRunCard: React.FunctionComponent = () => {
  const { dailyStats } = useAdvertisersDashboard();

  const data = React.useMemo(
    () => formatAdsRunData(dailyStats.data),
    [dailyStats],
  );

  return (
    <Card>
      <CardHeader title="When did my ads run?" />
      <CardContent component={Simplebar}>
        <Grid container spacing={2}>
          <Grid item xs={12} marginBottom={4} marginTop={4}>
            <ResponsiveContainer width="100%" height={70}>
              <BarChart height={40} data={data} maxBarSize={40} width={150}>
                <XAxis dataKey="date" tickLine={false} />
                <Bar dataKey="unitLoaded" fill={BAR_COLOR} />
              </BarChart>
            </ResponsiveContainer>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default AdsRunCard;
